import React from 'react';


export default function WritingHero() {
  return (
    <section className='writing-hero-background page-hero page-hero--writing'>
      <div className='hero-content row container-large'>
        <div className='hero-text page-hero__text'>
          <p className='page-hero__eyebrow'>Library</p>
          <h1>Writing</h1>
        </div>
        <div className='hero-img page-hero__media'>
          <img
            src={process.env.PUBLIC_URL + '/images/tys-covershot-2.webp'}
            alt='The Young Samaritan book stack'
          />
        </div>
      </div>
    </section>
  );
}
